export default {
  reviewCompleteHeader: '검토 및 완료',
  participants: '참여자',
  enterParticipantInfoText:
    '체험판에 참가자들 정보를 입력해 주세요. 남는 공간이 있을 경우, 참가자들을 더 추가해 주세요. ',
  purchaser: '구매자',
  firstName: '이름',
  lastName: '성',
  email: '이메일',
  optionalEmail: '이메일:(선택 사항)',
  'phone:': '전화 번호',
  duplicatePurchaserText: '구매자 정보와 같음',
  phone: '전화 번호:(선택 사항)',
  addParticipant: '추가 {{tierLabel}}',
  participant: '참가자',
  removeParticipant: '삭제',
  experienceCheckoutCompleted: '체험 결제 완료',
  experienceCartCheckout: '체험 장바구니 결제',
  experienceLimitReached: '죄송합니다. 최대 참가자 수에 도달했습니다.',
  payment: '결제',
  duration: '기간',
  discountCode: '할인 코드',
  removeCode: '코드 삭제',
  invalidCodeValidation: '쿠폰 코드 불일치',
  networkErrorDiscountCode: '저희 측에서 문제가 발생했습니다.',
  onlyOneCouponCodeAllowed: '할인 코드는 1개만 사용할 수 있습니다.',
  creditCodeHasAlreadyBeenApplied: '크레딧 코드는 이미 적용되었습니다.',
  discount: '할인',
  promo: 'Promo',
  promoCode: 'Promo code',
  apply: '신청하기',
  total: '합계',
  subTotal: 'Subtotal',
  includes: 'Includes',
  and: 'and',
  addHostNotes: '호스트를 위해 노트를 추가해 주세요.',
  brandAggreementText:
    '본인은 본 참가자를 대신하여 다음 이용 약관에 동의 할 권한이 있음을 동의하거나 증명합니다.',
  termsAggreementValidation: '약관에 동의해 주세요',
  firstNameValidation: '이름을 입력해 주세요',
  lastNameValidation: '성을 입력해 주세요',
  emailValidation: {
    'Invalid Email Address': '잘못된 이메일 주소',
    emailRequiredText: '이메일은 필수 입력 항목입니다',
    not_specified: '잘못된 이메일 주소입니다.',
  },
  phoneValidation: {
    'Invalid Phone Number': '잘못된 전화 번호',
    not_specified: '유효하지 않은',
  },
  participantFirstNameValidation: '참가자 이름은 필수 입력 항목입니다',
  participantLastNameValidation: '참가자 성은 필수 입력 항목입니다',
  complete: '완료',
  '404Message': '찾을 수 없음',
  waiting: '대기 중...',
  complimentary: '무료',
  confirmationHeader: '체험 예약이 완료되었습니다!',
  confirmationText:
    '{{email}} 로 추가 세부 정보가 포함된 확인 이메일이 전송되었습니다.',
  viewAll: '모든 체험 보기',
  paymentMethod: '결제 방법',
  creditCard: '신용카드',
  roomCharge: '방 요금',
  memberCharge: '회원 요금',
  memberNumber: '회원 번호',
  roomNumber: '방 번호',
  kicc: 'Easy Pay',
  chargeValidation: '방 번호와 성은 필수 입력 항목입니다',
  memberNumberValidation: '회원 번호와 성은 필수 입력 항목입니다',
  invalidMemberNumber: '회원 번호가 잘못되었습니다.',
  invalidRoomNumber: '방 번호가 올바르지 않습니다',
  cardNumberIncomplete: '카드 번호 미완료',
  lastNameValidationError: '성은 필수 입력 항목입니다',
  isReqd: '은(는) 필수입니다',
  private: '비공개',
  browseAllExperieces: '모든 체험 둘러보기',
  payWithCreditCard: '신용카드로 결제',
  payWithRoomCharge: '방 요금으로 결제',
  payWithMemberCharge: '회원 요금으로 결제',
  payWith: '결제 방법',
  bookBulkErrorByCard:
    '예약 확인 중 문제가 발생했습니다. 카드가 청구되지 않았습니다.',
  bookBulkErrorByRoomCharge: '잘못된 성 및 객실 번호입니다.',
  bookBulkErrorByMemberCharge: '잘못된 성과 회원번호입니다.',
  reviewCancellation: '예약 취소',
  selectAReservationToCancel: '취소할 예약을 선택하세요',
  confirmCancellation: '취소 확인',
  cancellable: '취소 가능',
  cancelled: '취소됨',
  deadlinePassed: '취소 기한이 지났습니다',
  noCancellations: '취소할 수 없습니다',
  reviewReschedule: '예약',
  selectAReservationToReschedule: '일정을 변경할 예약을 선택하세요',
  confirmReservation: '예약 확인',
  confirm: '확인하다',
  selectADateAndTime: '날짜와 시간을 선택하세요',
  noOtherSessionsAvailableForThisExperience:
    '이 체험에 사용할 수 있는 다른 세션이 없습니다.',
  thisReservationCanNoLongerBeRescheduledPleaseEmail:
    '이 예약은 더 이상 일정 변경이 불가능합니다. {{brandEmail}}로 이메일을 보내주세요',
  thisReservationCannotBeRescheduled: '이 예약은 일정 변경이 불가능합니다',
  noTimesAvailable: '사용 가능한 시간이 없습니다',
  noBookingsAvailable: '예약이 없습니다',
  youPaid: '지불하셨습니다',
  refund: '환불',
  yourRefund: '환불',
  yourRefundWillBeProcessedToTheOriginalPayment:
    '환불은 원래 결제 수단으로 처리됩니다.',
  thisReservationCanNoLongerBeCancelledPleaseEmail:
    '이 예약은 더 이상 취소할 수 없습니다. 이메일로 문의하세요 {{brandEmail}}',
  reservationCancelled: '예약이 취소되었습니다',
  thisReservationCannotBeCancelled: '이 예약은 취소할 수 없습니다',
  thisReservationHasAlreadyBeenCancelled: '이 예약은 이미 취소되었습니다',
  theHotel: '호텔',
  cancelling: '취소 중',
  somethingWentWrong: '문제가 발생했습니다',
  previouslyRefunded: '이전에 환불됨',
  remainingBalance: '잔액',
  phoneNumber: '전화 번호',
  requestToBookConfirmationText: '확인 이메일이 {{email}}로 전송되었습니다',
  reservationRescheduled: '예약이 재조정되었습니다',
  yourReservationWasRescheduledTo: '예약이 다음으로 재조정되었습니다:',
  viewExperiences: '체험 보기',
  joinBook: '참여하고 예약하기',
  signInBook: '로그인하고 예약하기',
  signAndJoin: '로그인 또는 참여하여 예약하기',
  signAndJoinDescription:
    'World of Hyatt FIND 체험은 World of Hyatt 회원만 전용입니다. 로그인 또는 참여하여 예약하고 포인트를 얻으세요. 로그인하지 않으시겠습니까? World of Hyatt Experience를 카트에서 제거하면 비전용 체험을 예약할 수 있습니다.',
  promoOrFind: '프로모션 또는 FIND 크레딧 코드',
  hyattTermsAndConditions: '이용 약관',
  hyattTermsAndConditionsAgreement:
    '이 예약을 확인함으로써 취소 정책에 동의합니다. 또한 아래의 개인 정보 사용에 대한 내용을 읽고 동의합니다:',
  hyattTermsAndConditionsLink: '하얏트 개인정보 보호정책',
  hyattWaiverText:
    '이 체험을 구매함으로써 나 자신과 내가 구매한 체험에 참여하는 모든 사람을 대신하여 다음 내용을 동의하고 이해하며 인정합니다',
  hyattWaiverLink: '일반 면책 조항',
  priceDisclaimer: '면제된 세금 전 금액을 포함합니다',
  curatedRecommendations: '추천 체험',
  moreExperiencesYouMightLike: '더 많은 체험을 찾아보세요',
  similarExperiencesAvailableToBookDirectly: '직접 예약할 수 있는 유사한 체험',
  experiencesAvailableAroundYourBookingDate: '예약 날짜 근처의 체험',
  confirmationEmailSent:
    '추가 세부 정보가 포함된 확인 이메일이 {{email}}로 전송되었습니다.',
  youreBooked: '예약되었습니다',
  purchaserInformation: '구매자 정보',
  requiredFieldIndicator: '* 필수 입력 항목',
  resourceSelectionTitle: '옵션 선택',
  resourceSelectionDescription: '예약의 각 항목에 대해 옵션을 선택하세요.',
  resourceUnitLabel: '{{tierName}} {{number}}',
  selectResourceAttribute: '{{attributeName}} 선택',
  resourceValueSoldOut: '{{label}} (매진)',
  resourceValueUnavailableWith: '{{label}} ({{picks}} 선택 시 이용 불가)',
  resourceOptionsUnavailable:
    '이 시간의 옵션을 불러오지 못했습니다. 다시 시도해 주세요.',
  resourceOptionsRetry: '다시 시도',
  changeResourceSelections: '선택 변경',
};
